var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_13_63",
    transform: "scale(0.0119048)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_13_63",
    width: 84,
    height: 84,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAAAXNSR0IArs4c6QAAAIRlWElmTU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgEoAAMAAAABAAIAAIdpAAQAAAABAAAAWgAAAAAAAABIAAAAAQAAAEgAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAAFSgAwAEAAAAAQAAAFQAAAAARFKgQwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAfdJREFUeAHt279Kw1AUx/H8oUshios4OPkYLiaDBITi1sVHcPER8gSuurj1EUqXDFEHX8PFqXQIAR0sNJ6CYobmnnC5gybfQiH05J5yPk3TkB/1PB4IIIAAAggggAACCCCAAAIIIIAAAggggAACCFgI+F3X5Hm+PxqNrn3fP5M1e13X/ff9ZN7VZrNZLJfLh+l0+qnN0wm0KIrjMAyfpNmJ1rCv9bquX6qqOp9MJh+mGQNT8acmmHeyPVjMrYMcqadRFGXbbdNDBZ3P5wfS4MLUZCi1IAiutFlV0PF4fChN1P20N+pJ/UjmMJ4mVaj1ev0mTdSTcU/AtDFeZYfatJMKmqbpu5yQZ6YmQ6mJw702qwq6bVCW5Y00e9aa9bw+k6udW21G4/mguTjLsiCO40v5tYvlGTVrfd6Wa9CVHEyLJEke+zwnsyGAAAIIIIAAAggggAACCCAwVIHON0cI6QjpnH5J5I4TIZ1LUUI6l5rfvQjp3KMS0jk2JaRzCUpI51LT8wjpXHgS0rlQpAcCCCCAAAIIIIAAAggggAACf1eAkE75bCT64J90ipFVmZDOiq19ESFdu411hZDOmq51ISFdK41dgZDOzm33KkK63S62rxLS2co11xHSNTXYRgABBBBAAAEEEEAAAQQQQAABBBBAAAEEfgW+ADtoy+agWmhGAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.132bf2a03944aff75ccc143468dc0814.svg";
export { ForwardRef as ReactComponent };